import * as React from "react";
import { PrivacyPolicyMarkdown } from "./Data";
import { Container } from "semantic-ui-react";
import Markdown from "../../components/WrappedMarkdown";

const PrivacyPage = () => (
	<Container>
		<Markdown source={PrivacyPolicyMarkdown} />
	</Container>
);

export default PrivacyPage;



// WEBPACK FOOTER //
// ./src/pages/PrivacyPage/PrivacyPage.tsx